<template>
  <div class="Borde">
    <div class="greenBorderBottom">
      <div class="numberContainer">
        <p class="greySubTitle">
          quedan <br>
          <span class="bigNumberStyle">{{ setPoints(deskNumber) }}</span>
        <br> por geocodificar
        </p>
      </div>
    </div>
    <div class="greySubTitle">
      de un total de <strong>{{total}}</strong> socs
    </div>
  </div>
</template>

<script>
export default {
  name: 'SmallDesk',
  data() {
    return {
    };
  },
  props: ['deskNumber', 'deskSubtitle', 'total'],
  methods: {
    setPoints(element) {
      if (element !== undefined) {
        return element.toLocaleString('es');
      } return 0;
    },
  },
  watch: {
    deskNumber() {
      this.setPoints();
    },
  },
};

</script>

<style lang="scss" scoped>
.bigNumberStyle {
  font-size: 20px;
  margin: 0;
  font-weight: 900;
}

.greySubTitle {
  font-weight: 300;
  font-size: 12px;
  margin: 0 0 0.5em 0;
  text-transform: uppercase;
  white-space: nowrap;
}
.Borde {
  width: auto;
  box-sizing: border-box;
  border: 1px solid $fb-grey-light-84;
  text-align: center;
}
.greenBorderBottom {
  &:after {
    content: "";
    display: block;
    width: 100%;
    margin: 0 auto;
    border-bottom: 6px solid $fb-green;
  }
}

.numberContainer{
  display: inline-block;
}

.textContainer{
  display: inline-block;
}

@media only screen and (max-width: 1300px) {
  .bigNumberStyle {
    font-size: 18px;
  }
  .greySubTitle {
    font-size: 10px;
  }
  .Borde {
    margin-top: -28px;
    margin-left: 15px;
  }
}

@media only screen and (max-width: 425px) {
  .greySubTitle {
    white-space: normal;
  }

  .greenBorderBottom {
    &:after {
      border-bottom: none;
    }
  }

  .greySubTitle {
    margin-top: 5px;
    padding: 5px;
    background: $fb-grey-light-94;
  }
}

@media only screen and (max-width: 424px) {
  .greenBorderBottom {
    width: 50%;
  }
}
</style>
